module.exports = __webpack_public_path__ + "img/serviceImg5.cfb9708e.png";